import { leftSideBarCasinoMain } from 'utils/casino/casino';
import { useCustomCategoriesUpdate } from './useCustomCategoriesUpdate';
import { useCategoriesFetch } from 'newelements/Casino/hooks/useCategoriesFetch';

type TUseOptionsParams = {
  shouldFetch?: boolean;
  providerIdsForCategories?: string;
  setExternalLoading?: (isLoading: boolean) => void;
};

export const useOptions = ({
  shouldFetch = false,
  providerIdsForCategories,
  setExternalLoading
}: TUseOptionsParams): void => {
  useCategoriesFetch({
    shouldFetch,
    providerIdsForCategories,
    setExternalLoading
  });
  useCustomCategoriesUpdate(
    shouldFetch,
    providerIdsForCategories,
    leftSideBarCasinoMain()
  );
};
